<template>
  <div>
    <div class="card">
      <div class="card-title border-bottom p-3 mb-0 header-title">
        {{$t('common.upload_resume.steps.step5.title')}}
        <a href="#"
          @click="showSk = true"
            class="btn btn-primary btn-sm btn-rounded float-right">
          <i class="uil-pen"></i>
        </a>
        </div>
        <div class="card-body" style="max-height:300px; overflow-y:scroll">
          <div class="text-center"
            v-if="model.skills.length == 0"
          >No skill/s found.</div>

          <div class="row icons-list font-size-15"
            
          >
          <span 
            v-for="(item, index) in model.skills"
            :key="`item-${item.uiid}`"
            class="font-weight-bold badge badge-soft-secondary m-2">{{item.name}}
              <button type="button" class="close" style="font-size: 18px;float: none;"
                @click="deleteSkill(index, item)">
                  <span>×</span>
              </button>
            </span>
        </div>
      </div>
    </div>

    <b-modal 
      v-model="showSk" 
      size="lg" 
      ref="skill"
      :title="(skill.uiid ? 'Edit' : 'Add') + ' Skill'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step5.window_skills.skill.placeholder')"
            :label="$t('common.upload_resume.steps.step5.window_skills.skill.label')"
            v-model="skill.name"
          />
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showSk = false">Close</b-button>
        <b-button variant="primary" @click="addSkill">{{ ( skill.uiid ? 'Update' : 'Add') + ' Skill' }}</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import TextField from '@components/form/textfield.vue'

export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        skills:[]
      },
      showSk:false,
      skill:{},
    }
  },
  components:{ TextField},
  methods: {
    async validate() {
      var isValid = true

      
      this.$emit('on-validate', null, isValid)
      return isValid
    },
    ...mapActions('prospect', [
      'createSkill', 
      'removeSkill',
    ]),
    addSkill(){
      delete this.skill._idx

      this.skill.candidate_id = this.$route.query.id
      this.createSkill(this.skill).then(res => {
        this.model.skills.push(res.data)
      })

      this.skill = {}
      this.showSk = false


    },
    deleteSkill(idx, item){
      /* this.model.skills.splice(idx, 1)
      this.skill = {} */

      this.removeSkill(item).then(res => {
        if(res.data.ok == 1){
          this.model.skills.splice(idx, 1)
          this.skill = {}
          this.$refs['education'].hide()
        }else{
          alert('Please try again')
        }
      })
    },
  },
  props:['data'],
  watch: { 
    data: function(newVal) { // watch it
      this.model.skills = newVal
    }
  }
}
</script>

